import React from 'react';
import { FaSearch, FaBell, FaUserCircle } from 'react-icons/fa';

function TopbarCom() {
  return (
    <div className="bg-white shadow-md p-4 flex justify-between items-center">
    <h1 className="text-xl font-bold text-gray-800">Dots Admin</h1>
    <div className="flex items-center gap-4">
      {/* <div className="relative hidden sm:block">
        <FaSearch className="text-gray-500 absolute left-3 top-3" />
        <input
          type="text"
          placeholder="Search..."
          className="pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <FaBell className="text-xl text-gray-500 cursor-pointer hover:text-gray-700" /> */}
      <FaUserCircle className="text-2xl text-gray-500 cursor-pointer hover:text-gray-700" />
    </div>
  </div>
  );
}

export default TopbarCom;